module.exports = __webpack_public_path__ + "img/upgrade.abfc1e38.png";